<div class="birth-time-input">
  <div class="birth-time-row">
    <div class="birth-time-field-wrap">
      <input
        #timeInput
        type="time"
        class="form-control birth-time-field"
        [value]="time()"
        (input)="onNativeTimeInput($event)"
        [attr.aria-label]="text().timeAria"
      />
      <button
        eBtn
        size="xs"
        compact
        squared
        type="button"
        class="birth-time-clock-btn"
        [tooltip]="text().chooseTime"
        [attr.aria-label]="text().chooseTime"
        (click)="openPicker(timeInput)"
      >
        <i eIcon icon="clock"></i>
      </button>
    </div>

    <span class="birth-time-hint">{{ text().timeFormatHint }}</span>

    <div
      class="birth-time-mode-group"
      role="group"
      [attr.aria-label]="text().timeModeGroupAria"
    >
      <button
        eBtn
        size="xs"
        compact
        type="button"
        class="birth-time-mode-button"
        [color]="!isUtc() ? 'primary-75' : 'highlight'"
        [textColor]="!isUtc() ? undefined : 'primary-75'"
        [attr.aria-pressed]="!isUtc()"
        (click)="setUtcMode(false)"
      >{{ text().localTime }}</button>
      <button
        eBtn
        size="xs"
        compact
        type="button"
        class="birth-time-mode-button"
        [color]="isUtc() ? 'primary-75' : 'highlight'"
        [textColor]="isUtc() ? undefined : 'primary-75'"
        [tooltip]="text().utcTooltip"
        [attr.aria-pressed]="isUtc()"
        (click)="setUtcMode(true)"
      >{{ text().utc }}</button>
    </div>
  </div>

  @if (isUtc()) {
    <p class="birth-time-utc-note">{{ text().utcNote }}</p>
  }
</div>
